const SCROLL_OVERFLOWS = ['auto', 'scroll'];

export const scrollerOf = (element: HTMLElement): HTMLElement | null => {
  for (let node = element.parentElement; node; node = node.parentElement) {
    if (SCROLL_OVERFLOWS.includes(getComputedStyle(node).overflowY)) {
      return node;
    }
  }
  return null;
};

/**
 * Scrolls the pane up until `element`'s top meets its top; never down.
 * Not `scrollIntoView`, which also pans the page sideways below `md`.
 */
export const scrollPaneUpTo = (element: HTMLElement) => {
  const pane = scrollerOf(element);
  if (!pane) {
    return;
  }
  const above =
    element.getBoundingClientRect().top - pane.getBoundingClientRect().top;
  if (above < 0) {
    pane.scrollTop += above;
  }
};
